import { all } from 'redux-saga/effects';
import searchSagas from '../../../../../shared/frontend/scripts/global-search/store/sagas';
import autoCompleteSagas from '../../../../../shared/frontend/scripts/global-search/autocomplete/store/sagas';
import { sagas as inReviewSagas } from '../in-review/modules';
import { sagas as userSagas } from '../user/modules';
import { sagas as groupCharterSagas } from '../../../../../shared/frontend/scripts/actions/groupCharter';
import { sagas as messageCenterSagas } from '../../../../../shared/frontend/scripts/messageCenter/modules';
import { sagas as teamSagas } from '../team/sagas';
import { sagas as threadSagas } from '../../../../../shared/frontend/scripts/thread/store/modules';
import recruitmentProfileCreationSagas from '../recruitmentProfiles/sagas';
import recruitmentSettingsSagas from '../recruitmentSettings/sagas';
import characterRecruitmentPageSagas from '../character/sagas';
import guildRecruitmentPageSagas from '../guild/sagas';
import localRecruitmentProfileSagas from '../shared/recruitment/components/RecruitmentProfilePreview/sagas';
import sharedRecruitmentSagas from '../shared/recruitment/sagas';
import replaysManagementSagas from '../replaysManagement/sagas';
import apiKeysManagementSagas from '../applicationsManagement/sagas';
// Admin sagas are loaded on-demand by their respective layout components:
// - eventsManagementSagas -> EventManagementLayout
// - timelineEventManagement -> TimelineEventManagementLayout
import eventUserRegistrationSagas from '../../../../../shared/frontend/scripts/events/store/details/sagas';
import eventTeamsSagas from '../../../../../shared/frontend/scripts/eventTeams/sagas';
import eventsSagas from '../../../../../shared/frontend/scripts/events/store/list/sagas';
import eventStandingsSagas from '../eventStandings/sagas';
import eventHubSagas from '../../../../../shared/frontend/scripts/event-hub/store/sagas';
import statisticsSagas from '../statistics/store/sagas';

import { groupCompositionCompareModule } from '../raiding/store/modules';
import siteMetaSagas from './siteMetaSagas';

export default function* rootSaga(): any {
  yield all([
    ...searchSagas,
    ...autoCompleteSagas,
    ...inReviewSagas,
    ...userSagas,
    ...groupCharterSagas,
    ...messageCenterSagas,
    ...teamSagas,
    ...threadSagas,
    ...siteMetaSagas,
    ...recruitmentProfileCreationSagas,
    ...recruitmentSettingsSagas,
    ...characterRecruitmentPageSagas,
    ...guildRecruitmentPageSagas,
    ...localRecruitmentProfileSagas,
    ...sharedRecruitmentSagas,
    ...replaysManagementSagas,
    ...apiKeysManagementSagas,
    ...eventUserRegistrationSagas,
    ...eventTeamsSagas,
    ...eventsSagas,
    ...eventStandingsSagas,
    ...eventHubSagas,
    ...statisticsSagas,

    ...groupCompositionCompareModule.sagas
  ]);
}
